// Vendor Libs
import { Component } from 'react';
import PropTypes from 'prop-types';

// Contexts
import { PanelContext } from '../../contexts/panel-context';

export default class PanelAction extends Component {
  constructor(props) {
    super(props);
    const { showPanel } = props;
    this.state = {
      registeredId: null,
      showPanel: typeof showPanel === 'undefined' ? false : showPanel,
    };
  }

  componentWillMount() {
    const { registerPanelAction } = this.context;
    const registeredId = registerPanelAction(this.getPanelActionParams());
    this.setState({ registeredId });
  }

  componentWillUpdate(nextProps) {
    const {updatePanelAction} = this.context;
    const {icon = 'search'} = this.props;
    const {registeredId, showPanel} = this.state;

    if (nextProps.showPanel && !showPanel) {
      this.setState({showPanel: true});
    }

    if (nextProps.icon !== icon) {
      updatePanelAction(registeredId, this.getPanelActionParams(nextProps));
    }
  }

  componentWillUnmount() {
    const { unregisterPanelAction } = this.context;
    const { registeredId } = this.state;
    unregisterPanelAction(registeredId);
  }

  getPanelActionParams(props = this.props) {
    const { groupByIcon, contentRenderer, hotkey, icon = 'search', title, weight } = props;
    return {
      groupByIcon,
      hotkey,
      icon,
      onClick: this.handlePanelActionClick,
      renderCallback: contentRenderer,
      title,
      weight,
    };
  }

  handlePanelActionClick = (event) => {
    const { canTogglePanel = true, onClick = () => undefined } = this.props;
    if (canTogglePanel) {
      this.setState((prevState) => ({ showPanel: !prevState.showPanel }));
    }
    onClick(event);
  };

  render() {
    const { showPanel } = this.state;
    const { contentRenderer } = this.props;
    return showPanel && contentRenderer ? contentRenderer() : null;
  }
}

PanelAction.propTypes = {
  canTogglePanel: PropTypes.bool,
  contentRenderer: PropTypes.func,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  showPanel: PropTypes.bool,
};

PanelAction.contextType = PanelContext;
